import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setCurrentEvent } from '../../actions';
import { BannerImage, Section } from '../../components';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";
import YoutubePlayer from 'react-youtube-player';
import Slider from 'react-slick';

import './styles.css';

class Location extends Component{
  constructor(props){
    super(props);
    this.state = {
      programTab: '',
      locationCoords: this.props.event.locationCoords,
    }
  }

  componentWillReceiveProps(props, state){
    // console.log("NEW PROPS RECIEVED", this.state.locationCoords !== props.event.locationCoords);
    if(this.state.locationCoords !== props.event.locationCoords){
      this.setState({locationCoords: props.event.locationCoords});
      // this.selectTab(Object.keys(this.props.event.program)[0]);
    }
    if(this.props.event !== props.event){
      this.selectTab(Object.keys(props.event.program)[0]);
    }
  }

  componentWillMount(){
    this.props.dispatch(setCurrentEvent(this.props.match.params.location));
    if(this.props.event.program && this.state.programTab === ''){
      this.selectTab(Object.keys(this.props.event.program)[0]);
    }
  }

  componentDidUpdate(prevProps){
    if(this.props.match.params.location !== prevProps.match.params.location){
      this.props.dispatch(setCurrentEvent(this.props.match.params.location));
    }
    if(this.props.event.program && this.state.programTab === ''){
      this.selectTab(Object.keys(this.props.event.program)[0]);
    }
  }

  renderVenue(){
    const AsyncMap = withScriptjs(
      withGoogleMap(
        props => (
          <GoogleMap
            defaultZoom={16}
            defaultCenter={{...props.location}}
            {...props}
          >
            <Marker
              position={{...props.location}}
            />
          </GoogleMap>
        )
      )
    )
    return (
      <div className="venue-name">
        <div className="flex">
          <div>
            <h5 className="uppercase">{this.props.event.venueNameTitle}</h5>
            <p>{this.props.event.venueName}</p>
          </div>
          <div>
            <div className="map">
            {this.state.locationCoords && this.state.locationCoords.constructor === Object && (
              <AsyncMap
                ref={(el) => {
                  this.mapComponent = el;
                }}
                location={{...this.state.locationCoords}}
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyAt5eNAxWjBYCLncLGl_hV1alaISard_8c&v=3.exp&libraries=geometry,drawing,places"
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div style={{ height: `300px` }} />}
                mapElement={<div style={{ height: `100%` }} />}
              />
            )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  render(){

    const settings = {
      dots: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <SampleNextArrow className='arrow-prev' />,
      prevArrow: <SamplePrevArrow className='arrow-next' />
    };


    return (
      <div>
        <BannerImage image={this.props.event.bannerImage} image2={this.props.event.bannerImage2} location={this.props.event.location} description={this.props.event.description} date={this.props.event.date} daterange={this.props.event.fromToDate} />

        <div className="locations-list-wrap">
          <Section className="location-list">
            <div>
              <h2><span className="color-red">DATE:</span><br/>
              {this.props.event.fromToDate}</h2>
            </div>
            <div>
              <h2><span className="color-red">CHALLENGE:</span><br/>
              {this.props.event.description}</h2>
              <p>{this.props.event.noteDescription}</p>
              <p>{this.props.event.fullDescription}</p>
            </div>
          </Section>
          <Section className="location-list">
            <div>
              <h2>Tech library</h2>
            </div>
            <div>
              <p>{this.props.event.techLibraryDesc}</p>
              <div className="tech-items flex">
                {this.props.event.techs && this.props.event.techs.map((tech, key) => {
                  return (
                    <div key={key} className="tech-item-box">
                      <div className="tech-avatar"><img src={tech.avatar} alt="{tech.name}" /></div>
                      <span>{tech.name}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          </Section>
          <Section className="location-list">
            <div>
              <h2>Venue</h2>
            </div>
            {this.renderVenue()}
          </Section>
          {/*}<Section className="location-list">
            <div>
              <h2>Judges</h2>
            </div>
            <div>
              <div className="judges flex">
                {this.props.event.judges && this.props.event.judges.map((judge, key) => {
                  return (<div key={key} className="judge-item-box">
                    <img src={judge.avatar} alt="avatar-duo" />
                    <div className="judge-item-text">
                      <span className="color-red">{judge.name}</span>
                      <span>{judge.position}</span>
                    </div>
                  </div>)
                })}
              </div>
            </div>
          </Section> */}
          <Section className="location-list">
            <div>
              <h2>Prizes</h2>
            </div>
            <div>
              <p>{this.props.event.prizes}</p>
            </div>
          </Section>
          <Section className="location-list">
            <div>
              <h2>Application</h2>
            </div>
            <div>
              <p>{this.props.event.applicationProcess}</p>
            </div>
          </Section>
          <Section className="location-list">
            <div>
              <h2>PROGRAM</h2>
            </div>
            <div>
              <div className="tabs two-tabs">
                {this.props.event.program && Object.keys(this.props.event.program).map((key, index) => {
                  return (
                    <div onClick={() => {
                      this.selectTab(key);
                    }} key={index} className={`tab-item ${key === this.state.programTab ? 'selected' : ''}`}>{key}</div>
                  );
                })}
              </div>
              <div className="tabs-content">
                {this.props.event.program && this.props.event.program[this.state.programTab] && (
                  this.props.event.program[this.state.programTab].map((item, key) => {
                    return (
                      <div key={key} className="tab-row">
                        <span className="tab-row-time">{item.time}</span>
                        <span className="tab-row-text">{item.text}</span>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </Section>
          <Section className="location-list">
            <div>
              <h2 className="TravelReimbursement">Travel<br/>Reimbursement</h2>
            </div>
            <div>
              <p>{this.props.event.travelReimbursement}</p>
            </div>
          </Section>


          {this.props.event.location === 'Sofia' && (

            <Section className="location-list">
              <div>
                <h2>SILICON VALLEY<br/>GUEST & JUDGE</h2>
              </div>
              <div>
                <div className="adidas-team flex">
                  {this.props.event.specialGuests && this.props.event.specialGuests.map((guest, key) => {
                    return (<div key={key} className="adidas-team-item-box">
                      <img src={guest.photo} alt="guest-avatar" className="photo" />
                      <div className="adidas-team-info">
                        <span className="name color-red">{guest.name}</span>
                        <span className="position">{guest.position}</span>
                        <span className="info">{guest.info}</span>
                      </div>
                    </div>)
                  })}
                </div>
              </div>
            </Section>

          )}

          <Section className="location-list">
            <div>
              <h2>adidas Team</h2>
            </div>
            <div>
              <div className="adidas-team flex">
                {this.props.event.adidasTeam && this.props.event.adidasTeam.map((teammate, key) => {
                  return (<div key={key} className="adidas-team-item-box">
                    <img src={teammate.photo} alt="teammate" className="photo" />
                    <div className="adidas-team-info">
                      <span className="name color-red">{teammate.name}</span>
                      <span className="position">{teammate.position}</span>
                      <span className="info">{teammate.info}</span>
                    </div>
                  </div>)
                })}
              </div>
            </div>
          </Section>

{this.props.event.locationVideo && this.props.event.locationVideo.map((video, key) => {
    return (

          <Section key={key} className="location-list">
            <div>
              <h2><img className="img-here-to-create" src="/img/here-to-create.png"  alt="Here to Create" /></h2>
            </div>
            <div>
              <div className="youtube-player">
                <YoutubePlayer
                    videoId={video.videoId}
                    playbackState='unstarted'
                    configuration={
                        {
                            showinfo: 0,
                            controls: 1,
                            autoplay: 0
                        }
                    }
                    />
                </div>
            </div>
          </Section>
    )
  })}


{this.props.event.photosSlider && this.props.event.photosSlider.map((slides, key) => {
    return (

          <Section key={key} className="location-list">
            <div>
              <h2>Gallery</h2>
            </div>
            <div>
                <Slider {...settings}>
                  <img src={slides.imgSlide1} alt=""/>
                  <img src={slides.imgSlide2} alt=""/>
                  <img src={slides.imgSlide3} alt=""/>
                  <img src={slides.imgSlide4} alt=""/>
                  <img src={slides.imgSlide5} alt=""/>
                  <img src={slides.imgSlide6} alt=""/>
                  <img src={slides.imgSlide7} alt=""/>
                  <img src={slides.imgSlide8} alt=""/>
                  <img src={slides.imgSlide9} alt=""/>
                  <img src={slides.imgSlide10} alt=""/>
                  <img src={slides.imgSlide11} alt=""/>
                  <img src={slides.imgSlide12} alt=""/>
                  <img src={slides.imgSlide13} alt=""/>
                  <img src={slides.imgSlide14} alt=""/>
                  <img src={slides.imgSlide15} alt=""/>
                  <img src={slides.imgSlide16} alt=""/>
                  <img src={slides.imgSlide17} alt=""/>
                  <img src={slides.imgSlide18} alt=""/>
                  <img src={slides.imgSlide19} alt=""/>
                  <img src={slides.imgSlide20} alt=""/>
                  <img src={slides.imgSlide21} alt=""/>
                  <img src={slides.imgSlide22} alt=""/>
                  <img src={slides.imgSlide23} alt=""/>
                  <img src={slides.imgSlide24} alt=""/>
                  <img src={slides.imgSlide25} alt=""/>
                  <img src={slides.imgSlide26} alt=""/>
                  <img src={slides.imgSlide27} alt=""/>
                  <img src={slides.imgSlide28} alt=""/>
                  <img src={slides.imgSlide29} alt=""/>
                  <img src={slides.imgSlide30} alt=""/>
                  <img src={slides.imgSlide31} alt=""/>
                  <img src={slides.imgSlide32} alt=""/>
                  <img src={slides.imgSlide33} alt=""/>
                  <img src={slides.imgSlide34} alt=""/>
                  <img src={slides.imgSlide35} alt=""/>
                  <img src={slides.imgSlide36} alt=""/>
                  <img src={slides.imgSlide37} alt=""/>
                  <img src={slides.imgSlide38} alt=""/>
                  <img src={slides.imgSlide39} alt=""/>
                  <img src={slides.imgSlide40} alt=""/>
                  <img src={slides.imgSlide41} alt=""/>
                  <img src={slides.imgSlide42} alt=""/>
                  <img src={slides.imgSlide43} alt=""/>
                  <img src={slides.imgSlide44} alt=""/>
                  <img src={slides.imgSlide45} alt=""/>
                  <img src={slides.imgSlide46} alt=""/>
                  <img src={slides.imgSlide47} alt=""/>
                  <img src={slides.imgSlide48} alt=""/>
                  <img src={slides.imgSlide49} alt=""/>
                  <img src={slides.imgSlide50} alt=""/>
                  <img src={slides.imgSlide51} alt=""/>
                  <img src={slides.imgSlide52} alt=""/>
                  <img src={slides.imgSlide53} alt=""/>
                  <img src={slides.imgSlide54} alt=""/>
                  <img src={slides.imgSlide55} alt=""/>
                  <img src={slides.imgSlide56} alt=""/>
                  <img src={slides.imgSlide57} alt=""/>
                  <img src={slides.imgSlide58} alt=""/>
                  <img src={slides.imgSlide59} alt=""/>
                  <img src={slides.imgSlide60} alt=""/>
                  <img src={slides.imgSlide61} alt=""/>
                  <img src={slides.imgSlide62} alt=""/>
                  <img src={slides.imgSlide63} alt=""/>
                  <img src={slides.imgSlide64} alt=""/>
                  <img src={slides.imgSlide65} alt=""/>
                  <img src={slides.imgSlide66} alt=""/>
                  <img src={slides.imgSlide67} alt=""/>
                  <img src={slides.imgSlide68} alt=""/>
                  <img src={slides.imgSlide69} alt=""/>
                  <img src={slides.imgSlide70} alt=""/>
                </Slider>

            </div>
          </Section>
  )
})}

          <Section className="location-list">
            <div>
              <h2 className="h2-collaborators">Collaborators</h2>
            </div>
            <div>
              <div className="collaborators flex">
              {this.props.event.collaborators && this.props.event.collaborators.map((collaborator, key) => {
                return (
                  <div key={key}>
                    {collaborator.collaboratorLink !== '' && (
                      <a href={collaborator.collaboratorLink} target="_blank"><img alt="colabotator" src={collaborator.collaboratorLogo} /></a>
                    )}
                    {collaborator.collaboratorLink === '' && (
                      <img alt="colaborator-logo" src={collaborator.collaboratorLogo} />
                    )}
                  </div>
                )
              })}
              </div>
            </div>
          </Section>

        </div>

      </div>
    );
  }
  selectTab(key){
    this.setState({programTab: key});
  }
}

var mapStateToProps = (state) => {
  return {
    event: state.challenges.currentChallenge
  }
}

function SampleNextArrow(props) {
  const {className, style, onClick} = props
  return (
    <div
      className={className}
      style={{...style}}
      onClick={onClick}
    ></div>
  );
}

function SamplePrevArrow(props) {
  const {className, style, onClick} = props
  return (
    <div
      className={className}
      style={{...style}}
      onClick={onClick}
    ></div>
  );
}

export default connect(mapStateToProps)(Location);



// WEBPACK FOOTER //
// ./src/screens/Location/Location.js